// import Constants from '@/utils/Constants';

let vm = null;

export default {
  created() {
    vm = this;
  },
  beforeDestroy() {
    vm = null;
  },
  methods: {
    $showErrorPage(errorCode, errorSub, errorInfo) {
      this.$router.push({
        name: 'ErrorGuide',
        params: {
          error_code: `${errorCode}`,
          error_sub: `${errorSub}`,
          error_info: errorInfo.info,
        },
      });
    },
    $showErrorToast(errorCode, errorMessage, errorInfo) {
      const message = [
        errorInfo.info,
        JSON.stringify(errorInfo.extra, null, 2),
      ];
      const h = this.$createElement;
      const vNodeMsg = h(
        'p',
        { class: ['text-left', 'mb-0'] },
        [
          message[0],
          h('hr'),
          h('pre', {}, [message[1]]),
        ],
      );
      this.$bvToast.toast([vNodeMsg], {
        title: `${errorCode} ${errorMessage}`,
        // solid: true,
        variant: 'primary-light',
        // noAutoHide: true,
        appendToast: true,
        toaster: 'b-toaster-bottom-right',
        toastClass: 'mb-3 mr-3',
      });
    },
  },
};

export const parseError = (err) => {
  const errorCode = err.response.data && err.response.data.code
    ? err.response.data.code
    : err.response.status;
  /* const errorMessage = err.response.data && err.response.data.message
    ? err.response.data.message
    : err.response.statusText; */
  const errorSub = err.response.data && err.response.data.payload
    ? err.response.data.payload.sub
    : '';
  const errorInfo = err.response.data && err.response.data.payload
    ? err.response.data.payload
    : { info: err.response.data };
  if (vm) {
    // if (Constants.isProduction) {
    vm.$showErrorPage(errorCode, errorSub, errorInfo);
    // return;
    // }
    /* if (![400, 422].includes(errorCode)) {
      vm.$showErrorPage(errorCode, errorSub, errorInfo);
    }
    vm.$showErrorToast(errorCode, errorMessage, errorInfo); */
  }
};
